import { Component, OnInit, EventEmitter, Output, Input, HostListener } from '@angular/core';
import { HeaderNsideService } from '../../services/HeaderNside.service';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { error } from 'protractor';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  adminName: string;

  adminPhoto: string = '/assets/img/avatar.svg';

  loadingPercentage: number;
  navCounter:boolean=false;
  showPercentage: boolean;
  screenHeightSidebarSa:any;
    screenWidthSidebarSa:any;


  constructor(private service: HeaderNsideService) {
    this.getScreenSizeSidebarSA();

   }

  ngOnInit() {
    this.showPercentage = false;
    this.service.getSideBarData().subscribe((data) => {
      this.adminName = data["Name"];
      this.adminPhoto = data["Photo"];
    });

  }

  @HostListener('window:resize', ['$event'])
  getScreenSizeSidebarSA(event?) {

    this.screenHeightSidebarSa = window.innerHeight;
    this.screenWidthSidebarSa = window.innerWidth;

  }

    //input for value from parent to child
@Input() navCounterInput:boolean=false;

//output for value from child to parent emitting event
@Output() navCounterOutput=new EventEmitter();
  public activeElement1 = 1;
  public selectedItem(id) {
      this.activeElement1 = id;
      this.firstComponentFunction();
      if(this.screenWidthSidebarSa<998){
        this.functionAfterHeightSA();
            }
   }

   functionAfterHeightSA(){
    this.service.onSidebarClickedMobileViewSA();
   }

  uploadPhoto(evt) {
    var File = evt.target.files;
    var Photo = File[0];

    if (Photo.name.search(/.jpg|.jpeg|.png|.tiff|.bmp /g) == -1) {
      alert('Please add an Image file ( jpg,jpeg,png,tiff,bmp )');
    } else if (File[0].size > 2000000) {
      alert(' Select an image of size upto 2 MB');
    } else {

    this.showPercentage = true;

      this.service.uploadAdminPhoto(Photo).subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.loadingPercentage = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type == HttpEventType.Response) {
          var reader = new FileReader();
          reader.onload = (abc: any) => {
            this.adminPhoto = abc.target.result;
          }
          reader.readAsDataURL(Photo);

        }

      }, (error: HttpErrorResponse) => { alert(error.statusText); }).add(() => {
        this.showPercentage = false;
      });
    }


  }
  firstComponentFunction() {
    this.service.onFirstComponentButtonClick();
  }

  toggleNavBar(){

        let status = this.navCounter == false ? true : false;
        this.navCounterInput=status;
        this.navCounter = status;
        this.navCounterOutput.emit(this.navCounterInput);
  }

}

